import { useRelevantQueryParams } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useReturns = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const [report, setReport] = useState<Report | null>(null);
    const [activeTab, setActiveTab] = useState<string>('active');
    const { openModal, closeModal } = useModals();
    const reportModalId = 'vending-returns-report-modal';
    const exportData: { [key: string]: any } = { ...useRelevantQueryParams(['tab']) };
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        ReportClient.fetchReports({ type: ReportType.VENDING_RETURNS, account_id: currentAccount }).then((res) => {
            if (res.results.length > 0) {
                setReport(res.results[0]);
            }
        });
    }, [currentAccount]);

    return {
        dispatch,
        currentAccount,
        report,
        activeTab,
        setActiveTab,
        openModal,
        closeModal,
        reportModalId,
        exportData,
        navigate,
        location
    };
};
